import {BrowserModule} from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';
import {IonicApp, IonicErrorHandler, IonicModule} from 'ionic-angular';
import {SplashScreen} from '@ionic-native/splash-screen';
import {StatusBar} from '@ionic-native/status-bar';

import {MyApp} from './app.component';
import {HttpClientModule} from '@angular/common/http';
import {ServiceProvider} from '../providers/service/service';
import {IonicStorageModule} from '@ionic/storage';
import {Device} from '@ionic-native/device';
import {PhotoViewer} from '@ionic-native/photo-viewer';
import {AndroidPermissions} from '@ionic-native/android-permissions';
import {File} from '@ionic-native/file';
import {FileTransfer, FileUploadOptions, FileTransferObject} from '@ionic-native/file-transfer';
import {FileOpener} from '@ionic-native/file-opener';
import {ActionSheet} from '@ionic-native/action-sheet';
import {Camera} from '@ionic-native/camera';
import {FileChooser} from '@ionic-native/file-chooser';
import {Contacts, Contact, ContactField, ContactName} from '@ionic-native/contacts';
import {SocialSharing} from '@ionic-native/social-sharing'
import {DatePicker} from '@ionic-native/date-picker';
import {DatePipe} from '@angular/common';
import {LoginPage} from "../pages/login/login";
import {HomePage} from "../pages/home/home";
import {DashboardHomePage} from "../pages/dashboard-home/dashboard-home";
import {EnquiryFormPage} from "../pages/enquiry-form/enquiry-form";
import {DataProgressPage} from "../pages/data-progress/data-progress";
import {EnquiryPage} from "../pages/enquiry/enquiry";
import {EnquiryRemarkPage} from "../pages/enquiry-remark/enquiry-remark";
import {EnquiryresponsePage} from "../pages/enquiryresponse/enquiryresponse";
import {EnquirystatusPage} from "../pages/enquirystatus/enquirystatus";
import {ParentFeedbackPage} from "../pages/parent-feedback/parent-feedback";
import {AdmissionPage} from "../pages/admission/admission";
import {AddAppointmentPage} from "../pages/add-appointment/add-appointment";
import {AppointmentsPage} from "../pages/appointments/appointments";
import {WebIntent} from '@ionic-native/web-intent';
import {DataCallLogPage} from '../pages/data-call-log/data-call-log';
import {InAppBrowser} from "@ionic-native/in-app-browser";
import {ListDataModelPage} from "../pages/list-data-model/list-data-model";
import {GuestPage} from "../pages/guest/guest";
import {AppVersion} from '@ionic-native/app-version';
import {Media} from "@ionic-native/media";
import {FeedbackPage} from "../pages/feedback/feedback";
import {NonenquirylogPage} from "../pages/nonenquirylog/nonenquirylog";
import {Sim} from "@ionic-native/sim";
import {DailyCallLogsPage} from "../pages/daily-call-logs/daily-call-logs";
import {DemoPaginationPage} from "../pages/demo-pagination/demo-pagination";
import {SubStatusHistoryPage} from "../pages/sub-status-history/sub-status-history";
import {CallStatusIsNullPage} from "../pages/call-status-is-null/call-status-is-null";
import {WhtspPage} from "../pages/whtsp/whtsp";
import {FeesPage} from "../pages/fees/fees";
import {ErpAdmissionPage} from "../pages/erp-admission/erp-admission";
import {FeesDetailsPage} from "../pages/fees-details/fees-details";
import {ProgressReportPage} from "../pages/progress-report/progress-report";
import {ContactPage} from "../pages/contact/contact";
import {DailyLogsPage} from "../pages/daily-logs/daily-logs";
import {AllProgressReportPage} from "../pages/all-progress-report/all-progress-report";
import {MonthwiseProgressReportPage} from "../pages/monthwise-progress-report/monthwise-progress-report";

import {CallEnquiryReminderPage} from "../pages/call-enquiry-reminder/call-enquiry-reminder";
import {AddCallReminderPage} from '../pages/add-call-reminder/add-call-reminder';
import {StdwiseStatusProgressPage} from "../pages/stdwise-status-progress/stdwise-status-progress";
import {DefaultProgressPage} from "../pages/default-progress/default-progress";
import {ArchiveStdWiseReportPage} from "../pages/archive-std-wise-report/archive-std-wise-report";
import {ArchiveSourceWiseReportPage} from "../pages/archive-source-wise-report/archive-source-wise-report";
import {ArchiveDateWiseReportPage} from "../pages/archive-date-wise-report/archive-date-wise-report";
import {ArchiveUserWiseReportPage} from "../pages/archive-user-wise-report/archive-user-wise-report";
import {AddJustdialDataPage} from "../pages/add-justdial-data/add-justdial-data";
import {DailyLogReportPage} from "../pages/daily-log-report/daily-log-report";
import {AllStdProgressReportPage} from "../pages/all-std-progress-report/all-std-progress-report";
import {ArchiveStdReasonsReportPage} from "../pages/archive-std-reasons-report/archive-std-reasons-report";
import {GetTotalAdmissionsPage} from "../pages/get-total-admissions/get-total-admissions";
import {GetContinueAdmissionsPage} from "../pages/get-continue-admissions/get-continue-admissions";
import {GetNewAdmissionsPage} from "../pages/get-new-admissions/get-new-admissions";
import {GetLeftAdmissionsPage} from "../pages/get-left-admissions/get-left-admissions";
import {DataProcessModulePage} from "../pages/data-process-module/data-process-module";
import {GeisAdmissionReportPage} from "../pages/geis-admission-report/geis-admission-report";
import {GweAdmissionReportPage} from "../pages/gwe-admission-report/gwe-admission-report";
import {GwwAdmissionReportPage} from "../pages/gww-admission-report/gww-admission-report";
import {MonthlyLogsReportPage} from "../pages/monthly-logs-report/monthly-logs-report";
import {SchoolEnquiryPage} from "../pages/school-enquiry/school-enquiry";
import {CommunicationPage} from "../pages/communication/communication";
import {DataProcessModuleLogsPage} from "../pages/data-process-module-logs/data-process-module-logs";
import {TotalNoOeEnQReportAllSchoolPage} from "../pages/total-no-oe-en-q-report-all-school/total-no-oe-en-q-report-all-school";
import {AllSchoolAdmisssionsReportPage} from "../pages/all-school-admisssions-report/all-school-admisssions-report";
import {PreviousSchoolsPage} from "../pages/previous-schools/previous-schools";
import {PreviousSchoolsStudentsPage} from "../pages/previous-schools-students/previous-schools-students";
import {DataLogPage} from "../pages/data-log/data-log";
import {DataProcessLogPage} from "../pages/data-process-log/data-process-log";
import {AllSchoolEnquiryReportsPage} from "../pages/all-school-enquiry-reports/all-school-enquiry-reports";
import {ArchivedDataTestingDataPage} from "../pages/archived-data-testing-data/archived-data-testing-data";
import {ArchivedDataRegardingJobPage} from "../pages/archived-data-regarding-job/archived-data-regarding-job";
import {StudentActivePage} from "../pages/student-active/student-active";
import {PreviousSchoolReportPage} from "../pages/previous-school-report/previous-school-report";
import {PredataCallLogsPage} from "../pages/predata-call-logs/predata-call-logs";
import {AddPredataCallReminderPage} from "../pages/add-predata-call-reminder/add-predata-call-reminder";
import {Calendar} from "@ionic-native/calendar";
import {SyncGoogleContactPage} from "../pages/sync-google-contact/sync-google-contact";
import {MonthwiseWebsiteEnqReportPage} from "../pages/monthwise-website-enq-report/monthwise-website-enq-report";
import {MonthwiseJustdialEnqReportPage} from "../pages/monthwise-justdial-enq-report/monthwise-justdial-enq-report";

@NgModule({
  declarations: [
    MyApp,
    LoginPage,
    HomePage,
    DashboardHomePage,
    EnquiryFormPage,
    DataProgressPage,
    EnquiryPage,
    EnquiryRemarkPage,
    EnquiryresponsePage,
    EnquirystatusPage,
    ParentFeedbackPage,
    AdmissionPage,
    AddAppointmentPage,
    AppointmentsPage,
    DataCallLogPage,
    ListDataModelPage,
    GuestPage,
    FeedbackPage,
    NonenquirylogPage,
    DailyCallLogsPage,
    DemoPaginationPage,
    SubStatusHistoryPage,
    CallStatusIsNullPage,
    WhtspPage,
    FeesPage,
    ErpAdmissionPage,
    FeesDetailsPage,
    ContactPage,
    ProgressReportPage,
    DailyLogsPage,
    AllProgressReportPage,
    MonthwiseProgressReportPage,
    CallEnquiryReminderPage,
    AddCallReminderPage,
    StdwiseStatusProgressPage,
    DefaultProgressPage,
    ArchiveStdWiseReportPage,
    ArchiveSourceWiseReportPage,
    ArchiveDateWiseReportPage,
    ArchiveUserWiseReportPage,
    AddJustdialDataPage,
    DailyLogReportPage,
    AllStdProgressReportPage,
    ArchiveStdReasonsReportPage,
    GetTotalAdmissionsPage,
    GetContinueAdmissionsPage,
    GetNewAdmissionsPage,
    GetLeftAdmissionsPage,
    DataProcessModulePage,
    GeisAdmissionReportPage,
    GweAdmissionReportPage,
    GwwAdmissionReportPage,
    MonthlyLogsReportPage,
    SchoolEnquiryPage,
    CommunicationPage,
    DataProcessModuleLogsPage,
    TotalNoOeEnQReportAllSchoolPage,
    AllSchoolAdmisssionsReportPage,
    PreviousSchoolsPage,
    PreviousSchoolsStudentsPage,
    DataLogPage,
    DataProcessLogPage,
    AllSchoolEnquiryReportsPage,
    ArchivedDataTestingDataPage,
    ArchivedDataRegardingJobPage,
    StudentActivePage,
    PreviousSchoolReportPage,
    PredataCallLogsPage,
    AddPredataCallReminderPage,
    SyncGoogleContactPage,
    MonthwiseWebsiteEnqReportPage,
    MonthwiseJustdialEnqReportPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot(),
    HttpClientModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    LoginPage,
    HomePage,
    DashboardHomePage,
    EnquiryFormPage,
    DataProgressPage,
    EnquiryPage,
    EnquiryRemarkPage,
    EnquiryresponsePage,
    EnquirystatusPage,
    ParentFeedbackPage,
    AdmissionPage,
    AddAppointmentPage,
    AppointmentsPage,
    DataCallLogPage,
    ListDataModelPage,
    GuestPage,
    FeedbackPage,
    NonenquirylogPage,
    DailyCallLogsPage,
    DemoPaginationPage,
    SubStatusHistoryPage,
    CallStatusIsNullPage,
    WhtspPage,
    FeesPage,
    ErpAdmissionPage,
    FeesDetailsPage,
    ContactPage,
    ProgressReportPage,
    DailyLogsPage,
    AllProgressReportPage,
    MonthwiseProgressReportPage,
    CallEnquiryReminderPage,
    AddCallReminderPage,
    StdwiseStatusProgressPage,
    DefaultProgressPage,
    ArchiveStdWiseReportPage,
    ArchiveSourceWiseReportPage,
    ArchiveDateWiseReportPage,
    ArchiveUserWiseReportPage,
    AddJustdialDataPage,
    DailyLogReportPage,
    AllStdProgressReportPage,
    ArchiveStdReasonsReportPage,
    GetTotalAdmissionsPage,
    GetContinueAdmissionsPage,
    GetNewAdmissionsPage,
    GetLeftAdmissionsPage,
    DataProcessModulePage,
    GeisAdmissionReportPage,
    GweAdmissionReportPage,
    GwwAdmissionReportPage,
    MonthlyLogsReportPage,
    SchoolEnquiryPage,
    CommunicationPage,
    DataProcessModuleLogsPage,
    TotalNoOeEnQReportAllSchoolPage,
    AllSchoolAdmisssionsReportPage,
    PreviousSchoolsPage,
    PreviousSchoolsStudentsPage,
    DataLogPage,
    DataProcessLogPage,
    AllSchoolEnquiryReportsPage,
    ArchivedDataTestingDataPage,
    ArchivedDataRegardingJobPage,
    StudentActivePage,
    PreviousSchoolReportPage,
    PredataCallLogsPage,
    AddPredataCallReminderPage,
    SyncGoogleContactPage,
    MonthwiseWebsiteEnqReportPage,
    MonthwiseJustdialEnqReportPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    ServiceProvider,
    Device,
    PhotoViewer,
    AndroidPermissions,
    File,
    FileTransfer,
    FileOpener,
    ActionSheet,
    Camera,
    FileChooser,
    SocialSharing,
    DatePicker,
    DatePipe,
    Contacts,
    WebIntent,
    InAppBrowser,
    AppVersion,
    Media,
    Sim,
    Calendar
  ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts